import React, { FC } from 'react';

// shared
import { ItemDropdown } from '../../../components/ItemDropdown';
import { globalStyle } from '../../../GlobalStyle';

// self
import { Header } from './Header';
import { Menu } from './Menu';
import { MenuItem } from './MenuItem';

// h
import { useMenuData } from './useMenuData';

// u
import { getFirstLetters } from './utils';
import styled from 'styled-components';

const Styles = styled.div`
    &&& {
        .top-menu-dropdown__title {
            padding-bottom: 1px;
        }
    }
`;

globalStyle`
  .product-top-menu-animation-container {
    z-index: 100000 !important;
  }

  .product-top-menu-popup.top-menu-dropdown__popup {
    padding: 10px 0 !important;
    border-radius: 2px;
  }
`;

type ProductTopMenuProps = {};
export const ProductTopMenu: FC<ProductTopMenuProps> = () => {
    const { menuList, current, navigation } = useMenuData();

    const getTitle = (title) => {
        switch (title) {
            case 'Behavior Data Warehouse':
                return 'BDW';
            default:
                return getFirstLetters(title).padStart(3, 'ZD');
        }
    };

    return (
        <Styles>
            <ItemDropdown
                align="left"
                title={(isActive, isPopupShow) => <Header title={getTitle(current)} isOpened={isPopupShow} />}
                popupClass="product-top-menu-popup"
                animationContainerClass={'product-top-menu-animation-container'}
            >
                <Menu>
                    {menuList.map((menu: { name: string; url?: string }) => {
                        return (
                            <MenuItem
                                selected={menu.name === current}
                                // @ts-ignore
                                onSelect={() => !menu.url && navigation(menu.name)}
                                url={menu.url}
                                key={menu.name}
                            >
                                {menu.name}
                            </MenuItem>
                        );
                    })}
                </Menu>
            </ItemDropdown>
        </Styles>
    );
};
